export default __webpack_public_path__ + "assets/front/scss/error.01fe2e4d97d3f2a9ad9b9876216ac034.css";